import React from 'react';

import { useParams } from 'react-router';

import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagemProps, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { ColunaDinamicaProps } from 'pages/cadastro/loja/types';

export type ColunasDinamicasRequestResult = RequestListagemProps & {
    data: ColunaDinamicaProps[];
};

export function useGetColunasDinamicas(): UseQueryResult<ColunasDinamicasRequestResult> {
    const { sort, page, filter, limit } = useListagemContext();
    const { idSecao } = useParams();

    const requestListagem = useRequestListagem();

    const requestGrupoExibicaoOptions: RequestOptionsType = {
        url: 'gestao/configuracaopropriedade',
        sort: [{ property: 'nrSequencia', direction: 'ASC' }],
        filter: [...filter, { property: 'idConfiguracaoPropriedadeGrupoExibicao', value: idSecao, operator: 'eq' }],
        page,
        limit: 20,
    };

    return useQuery<ColunasDinamicasRequestResult>([requestGrupoExibicaoOptions], () =>
        requestListagem(requestGrupoExibicaoOptions).then((res) => res.data),
    );
}
